export default __webpack_public_path__ + "static/media/plus.c1b6db15.svg";